export const METRIC_KEYS = ["spend", "impressions", "clicks", "conversions"];

export function metricValue(value) {
  if (value === null || value === undefined || value === "" || typeof value === "boolean") return null;
  if (typeof value !== "number" && typeof value !== "string") return null;
  if (typeof value === "string" && !value.trim()) return null;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : null;
}

export function metricSnapshot(campaign, now = Date.now()) {
  const metrics = Object.fromEntries(METRIC_KEYS.map((key) => [key, metricValue(campaign?.metrics?.[key])]));
  return { at: now, metrics };
}

export function appendObservation(history, snapshot) {
  if (!METRIC_KEYS.some((key) => snapshot.metrics[key] !== null)) return history;
  const previous = history[history.length - 1];
  if (previous && METRIC_KEYS.every((key) => previous.metrics[key] === snapshot.metrics[key])) return history;
  return [...history, snapshot].slice(-30);
}

export function metricRates(metrics) {
  return {
    ctr: metrics.impressions > 0 && metrics.clicks !== null ? metrics.clicks / metrics.impressions * 100 : null,
    cpc: metrics.clicks > 0 && metrics.spend !== null ? metrics.spend / metrics.clicks : null,
  };
}

export function refreshInterval(query) {
  return query?.state?.status === "error" ? 120000 : 30000;
}

export function chartPoints(history, key) {
  const values = history.filter((point) => point.metrics[key] !== null);
  if (values.length < 2) return "";
  const first = values[0].at;
  const duration = Math.max(1, values[values.length - 1].at - first);
  const ceiling = Math.max(1, ...values.map((point) => point.metrics[key]));
  return values.map((point) => `${10 + (point.at - first) / duration * 580},${140 - point.metrics[key] / ceiling * 120}`).join(" ");
}
